import React, { useEffect, useState } from 'react';
import classes from "./TermsModal.module.css";
import { FaXmark } from "react-icons/fa6";
import { useSelector } from 'react-redux';

import termsEnglish from "../locales/policies/terms.english.json";
import termsFrench from "../locales/policies/terms.french.json";

const languageMap = new Map([
    ["0", termsEnglish],
    ["1", termsFrench],
    ["2", termsFrench],
    ["3", termsFrench],
    ["4", termsFrench],
    ["5", termsFrench],
    ["6", termsFrench],
    ["7", termsFrench],
    ["8", termsFrench],
    ["9", termsFrench],
    ["10", termsFrench],
    ["11", termsFrench],
    ["12", termsFrench],
    ["13", termsFrench],
]);

// const languageMap = new Map([
//   ["0", policyEn],
//   ["1", policyFr],
//   ["2", policyAr],
//   ["3", policyPg],
//   ["4", policySwc],
//   ["5", policyAm],
//   ["6", policyEs],
//   ["7", policySn],
//   ["8", policyTp],
//   ["9", policyKg],
//   ["10", policyId],
//   ["11", policyKm],
//   ["12", policyRu],
//   ["13", policyOm],
// ]);

const TermsModal = ({ setTermsModal }) => {
    const { selectedLanguage } = useSelector(state => state.languageSlice);
    const [terms, setTerms] = useState(null);

    useEffect(() => {
        const mapped = languageMap.get(selectedLanguage) || languageMap.get("0");
        setTerms(mapped);
    }, [selectedLanguage]);

    if (!terms) return null;

    return (
           <div className={classes.container} onClick={() => setTermsModal(false)}>
            <div className={classes.sub_container} onClick={(e) => e.stopPropagation()}>
                <div className={classes.close_btn_container}>
                    <button type="button" className={classes.close_btn} onClick={() => setTermsModal(false)}>
                        <FaXmark className={classes.close_icon} />
                    </button>
                </div>

                <div className={classes.msg}>
                    <h2 className={classes.text}>{terms.title}</h2>
                    <p className={classes.paragraph}>{terms.description}</p>
                    <p className={classes.paragraph}>{terms.description2}</p>

                    {/* Service Info */}
                    <div className={classes.section}>
                        <h3 className={classes.heading}>{terms.product.name}</h3>
                        <p className={classes.paragraph}>{terms.product.description}</p>
                        <p className={classes.paragraph}>{terms.product.cost}</p>
                        <p className={classes.paragraph}>{terms.product.renewal}</p>
                    </div>

                    {/* Personal Information Collected */}
                    <div className={classes.section}>
                        <h3 className={classes.heading}>
                                {terms.personalInformation.heading}
                        </h3>
                        <h6 className={classes.paragraph}>
                                {terms.personalInformation.subHeading}

                            </h6>
                        <p className={classes.paragraph}>
                                {terms.personalInformation.desc}

                        </p>
                        {terms.personalInformation.informationCollected.map((item, i) => (
                            <p key={i} className={classes.paragraph}>• {item}</p>
                        ))}

                    </div>

                    <div className={classes.section}>
                        <h3>
                                       {terms.personalInformation.heading2}

                        </h3>
                        <h6 className={classes.paragraph}>{terms.personalInformation.subHeading2}</h6>
                        {terms.personalInformation.collectionPoints.map((item, i) => (
                            <p key={i} className={classes.paragraph}>• {item}</p>
                        ))}
                    </div>

                    {/* Usage of Information */}
                    <div className={classes.section}>
                        <h3 className={classes.heading}>
                            {terms.usageOfInformation.heading}
                        </h3>
                        <p className={classes.paragraph}>
                            {terms.usageOfInformation.subHeading}
                        </p>
                            <p className={classes.paragraph}>
                            {terms.usageOfInformation.subHeaidng2}
                        </p>
                        <ul className={classes.list}>
                            {terms.usageOfInformation.serviceProvision.map((item, i) => (
                                <li key={i}>{item}</li>
                            ))}
                        </ul>
                    </div>

                    {/* Marketing and Profiling */}
                    <div className={classes.section}>
                        <h3 className={classes.heading}>
                             {terms.marketingAndProfiling.heading}
                        </h3>
                        <p className={classes.paragraph}>{terms.marketingAndProfiling.description}</p>
                        <p className={classes.paragraph}>{terms.marketingAndProfiling.description2}</p>
                        <p className={classes.paragraph}>{terms.marketingAndProfiling.description3}</p>
                        <ul className={classes.list}>
                            {terms.marketingAndProfiling.optOutInstructions.map((method, i) => (
                                <li key={i}>{method}</li>
                            ))}
                        </ul>
                        {/* <p className={classes.paragraph}>{terms.marketingAndProfiling.note}</p> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsModal;


//    {/* Service Info */}
//                     <div className={classes.section}>
//                         <h3 className={classes.heading}>{terms.product.name}</h3>
//                         <p className={classes.paragraph}>{terms.product.description}</p>
//                         <p className={classes.paragraph}><strong>Cost:</strong> {terms.product.cost}</p>
//                         {/* <p className={classes.paragraph}><strong>Subscription Options:</strong> {terms.product.subscriptionOptions.join(', ')}</p> */}
//                     </div>

//                     {/* Personal Information Collected */}
//                     <div className={classes.section}>
//                         <h3 className={classes.heading}>Personal Information We Collect</h3>
//                         {terms.personalInformation.informationCollected.map((item, i) => (
//                             <p key={i} className={classes.paragraph}>• {item}</p>
//                         ))}
                       
//                     </div>

//                     <div className={classes.section}>
//                          <h3>When we collect your personal information</h3>
//                         {terms.personalInformation.collectionPoints.map((item, i) => (
//                             <p key={i} className={classes.paragraph}>• {item}</p>
//                         ))}
//                     </div>

//                     {/* Usage of Information */}
//                     <div className={classes.section}>
//                         <h3 className={classes.heading}>How We Use Your Information</h3>
//                         <ul className={classes.list}>
//                             {terms.usageOfInformation.serviceProvision.map((item, i) => (
//                                 <li key={i}>{item}</li>
//                             ))}
//                         </ul>
//                     </div>

//                     {/* Marketing and Profiling */}
//                     <div className={classes.section}>
//                         <h3 className={classes.heading}>Marketing and Profiling</h3>
//                         <p className={classes.paragraph}>{terms.marketingAndProfiling.description}</p>
//                         <p className={classes.paragraph}><strong>How to opt out:</strong></p>
//                         <ul className={classes.list}>
//                             {terms.marketingAndProfiling.optOutInstructions.map((method, i) => (
//                                 <li key={i}>{method}</li>
//                             ))}
//                         </ul>
//                         {/* <p className={classes.paragraph}>{terms.marketingAndProfiling.note}</p> */}
//                     </div>